export default {
  label: {
    title: {
      noCardsSelected: 'Ningún componente agregado al panel',
    },
    button: {
      addChartButton: 'Agregar componente',
    },
  },
};
